import { FC } from 'react';
import styled from 'styled-components';
import { Box, Typography } from '@mui/material';
import { WbSunnyOutlined } from '@mui/icons-material';

const Container = styled(Box)`
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => theme.spacing(2)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;

const PostsPlaceholder: FC = () => (
  <Container>
    <WbSunnyOutlined fontSize="large" />
    <Typography variant="h6">Watch this space</Typography>
    <Typography variant="body2" color="textSecondary">
      We'll be sharing all the latest Bambuser stories and news with you here.
    </Typography>
  </Container>
);

export default PostsPlaceholder;
